import calls from '@/backend/api-calls'

const state = () => ({
  materials: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.materials.map(d => d.id);
  }
}

// actions
const actions = {
  getMaterials: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.materials.get(parameters)
        .then(resp => {
          commit("setMaterials", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addMaterial: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.materials.post(data)
        .then(resp => {
          commit("insertMaterial", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateMaterial: ({commit}, { materialId, data }) => {
    return new Promise((resolve, reject) => {
      calls.material.put(materialId, data)
        .then(resp => {
          commit("insertUpdatedMaterial", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteMaterial: ({commit}, materialId) => {
    return new Promise((resolve, reject) => {
      calls.material.delete(materialId)
        .then(resp => {
          commit("removeMaterial", materialId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Material successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addImage: ({commit}, { materialId, data }) => {
    return new Promise((resolve, reject) => {
      calls.material.addImage(materialId, data)
        .then(resp => {
          commit("insertUpdatedMaterial", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setMaterials (state, data) {
    state.materials = data.results;
    state.pagination = data.pagination;
  },
  insertMaterial (state, data) {
    state.materials.push(data);
  },
  insertUpdatedMaterial (state, data) {
    state.materials.forEach((material, i) => {
      if (material.id == data.id) {
        state.materials.splice(i, 1, data);
      }
    })
  },
  removeMaterial (state, id) {
    state.materials.forEach((material, i) => {
      if (material.id == id) {
        state.materials.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}